import { DataSource } from '@angular/cdk/table';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActionListAccount, ActionListsAccountsStoreService } from './action-lists-accounts.store.service';
import { RemoveAccountDialogComponent } from './remove-acccount-dialog.component';

@Component({
  selector: 'app-action-list-accounts',
  templateUrl: './action-lists-accounts.component.html',
  styleUrls: ['../action-lists-details.component.scss', 'action-lists-accounts.component.scss'],
  standalone: false,
})
export class ActionListsAccountsComponent implements OnInit {
  @Input() actionListId: string;
  DateFormat = DateFormat;

  accountsDataSource: ActionListAccountsDataSource;
  readonly displayedColumns = ['name-address', 'modified', 'actions'];
  loading$: Observable<boolean>;
  hasMore$: Observable<boolean>;
  private deleteAccountDialogRef: MatDialogRef<RemoveAccountDialogComponent>;

  constructor(
    private actionListsAccountsStoreService: ActionListsAccountsStoreService,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loading$ = this.actionListsAccountsStoreService.loading$;
    this.hasMore$ = this.actionListsAccountsStoreService.hasMore$;
    this.accountsDataSource = new ActionListAccountsDataSource(this.actionListsAccountsStoreService, this.actionListId);
  }

  loadNextPage(): void {
    this.actionListsAccountsStoreService.loadMore();
  }

  removeAccount(account: ActionListAccount): void {
    this.dialog.closeAll();
    this.deleteAccountDialogRef = this.dialog.open(RemoveAccountDialogComponent, {
      width: '620px',
      data: { name: account.name },
    });
    this.deleteAccountDialogRef.componentInstance.removed.subscribe((result) => {
      if (result) {
        this.actionListsAccountsStoreService.removeAccount(account.accountGroupId, this.actionListId);
      }
    });
  }
}

class ActionListAccountsDataSource extends DataSource<any> {
  accounts$: Observable<ActionListAccount[]>;
  loading$: Observable<boolean>;
  totalAccounts$: Observable<number>;
  totalAccountsText$: Observable<string>;
  pageSize = 25;

  constructor(
    private actionListsAccountsStoreService: ActionListsAccountsStoreService,
    private actionListId: string,
  ) {
    super();
    this.accounts$ = this.actionListsAccountsStoreService.accounts$;
    this.loading$ = this.actionListsAccountsStoreService.loading$;
    this.totalAccounts$ = this.actionListsAccountsStoreService.totalAccounts$;
    this.actionListsAccountsStoreService.loadAccounts(this.actionListId);
    this.totalAccountsText$ = this.totalAccounts$.pipe(
      map((totalAccounts) => {
        return totalAccounts === 1 ? `${totalAccounts} account` : `${totalAccounts} accounts`;
      }),
    );
  }

  connect(): Observable<ActionListAccount[]> {
    return this.accounts$;
  }

  disconnect(): void {
    return; // so lint is happy
  }
}
